const { Lock } = require("react-feather");

const MatchingChip = ({ onClick, theme, variant = 1, className }) => {
    const LABELS = {
        idb: {
            1: 'IDB · BANK ONLY',
            2: 'IDB',
            3: 'IDB · MARKETS',
        },
        agy: {
            1: 'AGENCY · MARKETS',
            2: 'AGY',
        },
    };
    const label = LABELS[theme]?.[variant];

    return (
        <div className={`px-1.5 rounded border inline-flex items-center gap-1 w-fit h-4 ${className} text-nowrap ${theme === 'idb' ? 'border-idb-500/10 bg-idb-500/20 text-idb-500' : 'border-success-500/10 bg-success-500/20 text-success-500'} text-[10px] font-medium cursor-pointer`} onClick={onClick}>
            {(variant === 1 || variant === 3) && <Lock size={10} className={`${theme === 'idb' ? 'text-idb-500' : 'text-success-500'}`} />}
            <span>{label}</span>
        </div>
    );
}
export default MatchingChip;